import { useCallback, useEffect, useState } from "react";
import axios from "../api/axiosConfig";
import useRealtimeRefresh from "./useRealtimeRefresh";

// Number of conversations with something unread, for the header badge.
// Updated instantly by the server push ("messages" event), re-read when the
// tab becomes visible again, with a slow fallback poll while visible. The
// messages page also dispatches "messages:changed" after reading or sending.
export default function useUnreadMessages(enabled = true, fallbackMs = 120000) {
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get("/messages/unread-count");
      setUnread(Number(res.data?.unread) || 0);
    } catch {
      // The badge is best-effort; stay quiet if the server is unreachable.
    }
  }, []);

  useRealtimeRefresh("messages", refresh, { enabled, fallbackMs });

  useEffect(() => {
    if (!enabled) return undefined;
    window.addEventListener("messages:changed", refresh);
    return () => window.removeEventListener("messages:changed", refresh);
  }, [enabled, refresh]);

  return { unread, refresh };
}
